// extracted by mini-css-extract-plugin
export var cardLayout = "_8b-1";
export var paginationContainer = "_8b-0";